import { GuidService } from './guid-service';
import { SubscribableService } from './subscribable-service';

const DEFAULT_HOTKEY_DURATION = 1000;
const HOTKEY_HIDE_ANIMATION_DURATION = 600;

const hotkeys = {};
const hotkeysToRemove = {};

class HotkeyDisplayServiceClass extends SubscribableService {
  getHotkeys() {
    return hotkeys;
  }

  showHotkey(hotkeyInputBuffer) {
    const id = GuidService.newGuid();
    const hotkey = { id, ...hotkeyInputBuffer };
    hotkeys[id] = hotkey;
    this.onChange();
    setTimeout(() => this.removeHotkey(id), DEFAULT_HOTKEY_DURATION);
    return id;
  }

  removeHotkey = (hotkeyId) => {
    hotkeysToRemove[hotkeyId] = hotkeys[hotkeyId];
    this.onChange();
    setTimeout(() => {
      this.completelyRemoveHotkey(hotkeyId);
    }, HOTKEY_HIDE_ANIMATION_DURATION);
  };

  completelyRemoveHotkey(hotkeyId) {
    delete hotkeys[hotkeyId];
    delete hotkeysToRemove[hotkeyId];
    this.onChange();
  }
}

export const HotkeyDisplayService = new HotkeyDisplayServiceClass();
